module.exports = __webpack_public_path__ + "img/e12.ee64e5c0.jpg";